export default __webpack_public_path__ + "static/media/d.ec40111a.jpg";